export default function WavyPath(
  props: React.ComponentProps<'svg'> & { color?: string }
): JSX.Element {
  const { color } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="11" {...props}>
      <defs>
        <pattern
          id={`${color}-wave`}
          viewBox="0 0 46 11"
          height="11"
          width="46"
          patternUnits="userSpaceOnUse"
          transform="rotate(90deg)"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-34.5 2.933c-3.575 0-7.191 1.251-10.864 3.828l-1.27-2.522C-42.642 1.438-38.592 0-34.5 0c4.091 0 8.141 1.438 12.135 4.24 3.673 2.576 7.29 3.827 10.865 3.827S-4.308 6.816-.635 4.239C3.36 1.438 7.41 0 11.501 0c4.091 0 8.141 1.438 12.135 4.24 3.673 2.576 7.29 3.827 10.865 3.827s7.191-1.251 10.864-3.828C49.36 1.438 53.41 0 57.501 0c4.091 0 8.142 1.438 12.135 4.24 3.673 2.576 7.29 3.827 10.865 3.827s7.191-1.251 10.864-3.828l1.27 2.522C88.643 9.562 84.593 11 80.5 11c-4.09 0-8.14-1.438-12.135-4.24-3.673-2.576-7.289-3.827-10.864-3.827-3.576 0-7.192 1.251-10.865 3.828C42.642 9.562 38.592 11 34.501 11c-4.092 0-8.142-1.438-12.136-4.24-3.673-2.576-7.289-3.827-10.864-3.827-3.576 0-7.192 1.251-10.865 3.828C-3.358 9.562-7.408 11-11.499 11c-4.092 0-8.142-1.438-12.136-4.24-3.673-2.576-7.289-3.827-10.864-3.827z"
            fill={color ?? 'yellow.solid'}
          />
        </pattern>
      </defs>
      <rect fill={`url(#${color}-wave)`} x="0" y="0" width="100%" height="11" />
    </svg>
  )
}
